import _sumBy from 'lodash/sumBy';

import { detectionIsOn, getDetectionStatusUpdate } from '@trqk/utils';

interface GetDetectionStatsInput {
    detectionTracks: DetectionTrack[];
    detectionCapacity: Maybe<number>;
    planType: ChargebeePlanId | null;
}

export const getDetectionStats = ({
    detectionTracks,
    detectionCapacity,
    planType,
}: GetDetectionStatsInput): DetectionStats => {
    const enabledAll = _sumBy(
        detectionTracks,
        ({ detection_history }: DetectionTrack): number => {
            const statusUpdate = getDetectionStatusUpdate({
                detectionHistory: detection_history,
            });

            if (detectionIsOn(statusUpdate?.status ?? null)) {
                return 1;
            }

            return 0;
        },
    );

    const enabledNonDraft = _sumBy(
        detectionTracks,
        ({ detection_history }: DetectionTrack): number => {
            const statusUpdate = getDetectionStatusUpdate({
                detectionHistory: detection_history,
                nonDraftOnly: true,
            });

            if (detectionIsOn(statusUpdate?.status ?? null)) {
                return 1;
            }

            return 0;
        },
    );

    return {
        detectionTracksCount: detectionTracks?.length ?? 0,
        detectionCapacity,
        enabled: {
            nonDraftOnly: enabledNonDraft,
            all: enabledAll,
        },
        planType,
    };
};
